module.exports = __webpack_public_path__ + "static/media/secretariat.4a1ed668.png";